import React from "react";
import ArrayFieldSection from "./ArrayFieldSection";
import "./FormFieldRenderer.css";

const FormFieldRenderer = ({ field, formData, setFormData, dropdownData }) => {
  const value = formData[field.fields] || (field.multiple ? [] : "");

  const handleChange = (e) => {
    const { name, type, value, selectedOptions, multiple } = e.target;
    if (multiple) {
      const values = Array.from(selectedOptions).map((opt) => opt.value);
      setFormData((prev) => ({ ...prev, [name]: values }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "number" ? parseInt(value, 10) : value,
      }));
    }
  };

  // If this is an array field with subfields, delegate rendering
  if (field.subfields) {
    return (
      <ArrayFieldSection
        field={field}
        formData={formData}
        setFormData={setFormData}
        dropdownData={dropdownData}
      />
    );
  }

  const baseField = field.fields;
  const labelText = field.title || baseField;

  return (
    <div
      className={`DynamicFormCreategroup DynamicFormCreategroup--${baseField}`}
    >
      <label
        className={`DynamicFormCreatelabel DynamicFormCreatelabel--${baseField}`}
      >
        {labelText}
      </label>

      {/* API-based dropdown */}
      {field.api && field.type === "ObjectId" ? (
        <select
          className={`DynamicFormCreateselect DynamicFormCreateselect--${baseField}`}
          name={baseField}
          value={value}
          onChange={handleChange}
          required
          multiple={field.multiple}
        >
          {!field.multiple && <option value="">{`Select ${labelText}`}</option>}
          {dropdownData[baseField]?.map((item) => (
            <option key={item.id} value={item.id}>
              {item[field.apiField] || item.label || item.name}
            </option>
          ))}
        </select>
      ) : field.options ? (
        // Enum dropdown
        <select
          className={`DynamicFormCreateselect DynamicFormCreateselect--${baseField}`}
          name={baseField}
          value={value}
          onChange={handleChange}
          required
        >
          <option value="">Select {labelText}</option>
          {field.options.map((opt, i) => (
            <option key={i} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      ) : field.type === "number" ? (
        <input
          className={`DynamicFormCreateinput DynamicFormCreateinput--number DynamicFormCreateinput--${baseField}`}
          type="number"
          name={baseField}
          value={value}
          onChange={handleChange}
          required
          inputMode="numeric"
          pattern="[0-9]*"
          onKeyDown={(e) => {
            if (
              ["e", "E", "+", "-", "."].includes(e.key) ||
              e.key === " " ||
              (isNaN(Number(e.key)) && e.key.length === 1)
            ) {
              e.preventDefault();
            }
          }}
        />
      ) : field.type === "date" ? (
        <input
          className={`DynamicFormCreateinput DynamicFormCreateinput--date DynamicFormCreateinput--${baseField}`}
          type="date"
          name={baseField}
          value={value}
          onChange={handleChange}
          required
        />
      ) : (
        <input
          className={`DynamicFormCreateinput DynamicFormCreateinput--text DynamicFormCreateinput--${baseField}`}
          type="text"
          name={baseField}
          value={value}
          onChange={handleChange}
          required
        />
      )}
    </div>
  );
};

export default FormFieldRenderer;
